/**
 * Composant pour les actions du Modal (pied de page)
 * 
 * @param {Object} props - Les props du composant
 * @param {ReactNode} props.children - Contenu des actions
 * @param {string} props.className - Classes additionnelles
 * @returns {JSX.Element} Le composant ModalActions
 */
const ModalActions = ({ 
  children, 
  className = '' 
}) => {
  return (
    <div className={`modal-action ${className}`}>
      {children}
    </div>
  )
}

// ModalActions.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string
// }

export default ModalActions